// src/data/educational.js
// Educational mock data for listings
const educationalListings = [
  {
    id: 1,
    institutename: 'Raman  Pre School',
    typecategory: 'Pre School',
    locationname: 'Mangalore',
    areaname: 'Kankanady',
    address1: '123 Cityside Ave, Kankanady, Mangalore, KA',
    contactnumber: '+91-###-###0000',
    contactperson: 'Mrs. Anitha Rao',
    emailid: 'anitha.rao@example.com',
    website: 'http://www.ramanpreschool123.com',
    aboutdescription: 'Nursery and kindergarten with experienced staff and a nurturing environment.',
    photos: ['/images/educationalimages/1_mangalore_kankanady_a1.jpg'],
    listorder: 1,
    dateListed: '2025-09-20',
    featuredlisting: true,
    AccountStatus: true,
  },
  {
    id: 2,
    institutename: 'Mangalore Arts College',
    typecategory: 'Degree',
    locationname: 'Mangalore',
    areaname: 'Urva',
    address1: '4543 College Road, Urva, Mangalore, KA',
    contactnumber: '+91-###-######1',
    contactperson: 'Mr. Rajesh Kumar',
    emailid: 'rajesh.kumar@example.com',
    website: 'http://www.mangaloreartsc#####.edu',
    aboutdescription: 'Well-equipped institute offering undergraduate and postgraduate courses in arts.',
    photos: ['/images/educationalimages/2_mangalore_urva_a1.jpg'],
    sm_instagram: 'mangalore_arts_college123',
    sm_facebook: 'mangalore_arts_college123',
    sm_youtube: 'mangalore_arts_college123',
    listorder: 9,
    dateListed: '2025-09-18',
    featuredlisting: true,
    AccountStatus: true,
  },
  
  {
    institutename: 'Bondel Business School',
    typecategory: 'Post Graduate',
    locationname: 'Mangalore',
    areaname: 'Bondel',
    address1: '5690 Corporate Blvd, Bondel, Mangalore, KA',
    contactnumber: '+91-###-###3333',
    contactperson: 'Ms. Priya Shenoy',
    emailid: 'priya.shenoy@example.com',
    website: 'http://www.bondelbusinessschool.edu',
    aboutdescription: 'Well-equipped institute offering postgraduate courses in business.',
    photos: ['/images/educationalimages/mangalore_a7.jpg'],
    sm_instagram: 'bondel_business_school123',
    sm_facebook: 'bondel_business_school123',
    sm_youtube: 'bondel_business_school123',
    listorder: 4,
    dateListed: '2025-09-10',
    featuredlisting: true,
    AccountStatus: true,
  },
  
  {
    id: 6,
    institutename: 'Kottara Science Academy',
    typecategory: 'PU College',
    locationname: 'Mangalore',
    areaname: 'Kottara',
    address1: '9 Hilltop ######, Kottara, Mangalore, KA',
    contactnumber: '+91-###-######4',
    contactperson: 'Ms. Leena Dsouza',
    emailid: 'leena.dsouza@example.com',
    website: 'http://www.kottarascienceacademy123.edu',
    aboutdescription: 'Well-equipped institute offering undergraduate and diploma courses in science.',
    photos: ['/images/educationalimages/6_mangalore_kottara_a1.jpg'],
    sm_instagram: 'kottara_science_academy',
    sm_facebook: 'kottara_science_academy',
    sm_youtube: 'kottara_science_academy',
    listorder: 5,
    dateListed: '2025-09-05',
    featuredlisting: true,
    AccountStatus: false,
  },
  {
    id: 7,
    institutename: 'Bejai Language Institute',
    typecategory: 'Language studies',
    locationname: 'Mangalore',
    areaname: 'Bejai',
    address1: '34 Cultural St, Bejai, Mangalore, KA',
    contactnumber: '+91-###-###5555',
    contactperson: 'Mr. Vijay Nair',
    emailid: 'vijay.nair@example.com',
    website: 'http://www.bejailanguageinstitute.edu',
    aboutdescription: 'Well-equipped institute offering undergraduate and postgraduate courses in languages.',
    photos: ['/images/educationalimages/7_mangalore_bejai_a1.jpg'],
    sm_instagram: 'bejai_language_institute',
    sm_facebook: 'bejai_language_institute',
    sm_youtube: 'bejai_language_institute',
    listorder: 15,
    dateListed: '2025-09-03',
    featuredlisting: false,
    AccountStatus: true,
  },
  {
    id: 8,
    institutename: 'Kinnimulki Technical College',
    typecategory: 'Diploma',
    locationname: 'Udupi',
    areaname: 'Kinnimulki',
    address1: '62347 Industrial Area, Kinnimulki, Udupi, KA',
    contactnumber: '+91-###-######6',
    contactperson: 'Mr. Ramesh N Shetty',
    emailid: 'ramesh.shetty@example.com',
    website: 'http://www.kinnimulkitechnicalcollege.edu',
    aboutdescription: 'Well-equipped institute offering Diploma courses in technology.',
    photos: ['/images/educationalimages/8_udupi_kinnimulki_a1.jpg'],
    sm_instagram: 'kinnimulki_technical_college',
    sm_facebook: 'kinnimulki_technical_college',
    sm_youtube: 'kinnimulki_technical_college',
    listorder: 6,
    dateListed: '2025-09-01',
    featuredlisting: true,
    AccountStatus: true,
  },
  {
    id: 101,
    institutename: 'Kulshekar Dominic Education Institute',
    typecategory: 'Primary/High school',
    locationname: 'Mangalore',
    areaname: 'Kulshekar',
    address1: 'Plot #12, Sunrise Avenue, Kulshekar, Mangalore, KA',
    contactnumber: '+91-###-#######7',
    contactperson: 'Mr. Dominic D\'souza',
    emailid: 'dominic.dsouza@example.com',
    website: 'http://www.kulshekardominiceducationinstitute.edu',
    aboutdescription: 'Well-equipped institute offering Primary, High School facilities.',
    photos: ['/images/educationalimages/101_mangalore_kulshekar_a1.jpg'],
    sm_instagram: 'kulshekar_dominic_education_institute123',
    sm_facebook: 'kulshekar_dominic_education_institute123',
    sm_youtube: 'kulshekar_dominic_education_institute123',
    listorder: 7,
    dateListed: '2025-09-19',
    featuredlisting: true,
    AccountStatus: true,
  },
  {
    id: 102,
    institutename: 'Vivek Institute of Commerce',
    typecategory: 'Degree',
    locationname: 'Udupi',
    areaname: 'Udyavara',
    address1: 'Plot #8, Commerce Street, Udyavara, Udupi, KA',
    contactnumber: '+91-###-######8',
    contactperson: 'Ms. Viveka Pai',
    emailid: 'viveka.pai@example.com',
    website: 'http://www.vivekinstituteofcommerce123.edu',
    aboutdescription: 'Well-equipped institute offering certificate courses in learning.',
    photos: ['https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80'],
    sm_instagram: 'vivek_institute_of_commerce',
    sm_facebook: 'vivek_institute_of_commerce',
    sm_youtube: 'vivek_institute_of_commerce',
    listorder: 8,
    dateListed: '2025-09-16',
    featuredlisting: true,
    AccountStatus: true,
  },
  
  {
    id: 14,
    institutename: 'Zeal Coaching Center',
    typecategory: 'Coaching',
    locationname: 'Mangalore',
    areaname: 'Kadri',
    address1: 'Plot #121344, Kadri Residency',
    contactnumber: '+91-###-######2',
    contactperson: 'Mr. Arun Prakash',
    emailid: 'arun.prakash@example.com',
    aboutdescription: 'We provide coaching for various competitive exams.',
    photos: ['/images/educationalimages/14_mangalore_kadri_a1.jpg'],
    sm_instagram: 'zeal_coaching_center123',
    sm_facebook: 'zeal_coaching_center123',
    sm_youtube: 'zeal_coaching_center123',
    listorder: 10,
    dateListed: '2025-09-11',
    featuredlisting: true,
    AccountStatus: true,
  },
  {
    id: 18,
    institutename: 'Pandeshwar Institute of Technology',
    typecategory: 'Engineering',
    locationname: 'Mangalore',
    areaname: 'Pandeshwar',
    address1: 'Plot #10, Pandeshwar Residency',
    contactnumber: '+91-###-######3',
    contactperson: 'Dr. Manish B Shetty',
    emailid: 'manish.shetty@example.com',
    website: 'http://www.pandeshwarinstituteoftechnology.edu',
    aboutdescription: 'Well-equipped institute offering undergraduate and postgraduate courses in engineering.',
    photos: ['/defaultimages/imagenotavailable.jpg'],
    sm_instagram: 'pandeshwar_institute_of_technology123',
    sm_facebook: 'pandeshwar_institute_of_technology123',
    sm_youtube: 'pandeshwar_institute_of_technology123',
    listorder: 11,
    dateListed: '2025-09-11',
    featuredlisting: false,
    AccountStatus: true,
  },
  {
    id: 19,
    institutename: 'Global Institute of Vocational Studies',
    typecategory: 'Vocational',
    locationname: 'Mangalore',
    areaname: 'Pandeshwar',
    address1: 'Plot #10, Pandeswar Residency',
    contactnumber: '+91-###-#######4',
    contactperson: 'Ms. Anjali S Kumar',
    emailid: 'anjali.kumar@example.com',
    website: 'http://www.globalinstituteofvocationalstudies.edu',
    aboutdescription: 'Well-equipped institute offering undergraduate and postgraduate courses in vocational studies.',
    photos: ['/images/educationalimages/mangalore_a3.jpg'],
    sm_instagram: 'global_institute_of_vocational_studies',
    sm_facebook: 'global_institute_of_vocational_studies',
    listorder: 12,
    dateListed: '2025-09-11',
    featuredlisting: true,
    AccountStatus: true,
  },
  {
    id: 20,
    institutename: 'Natya Dance Academy',
    typecategory: 'Dance Academy',
    locationname: 'Mangalore',
    areaname: 'Pandeshwar',
    address1: 'Plot #10, Pandeswar Residency',
    contactnumber: '+91-###-#######5',
    contactperson: 'Ms. Radha Menon',
    emailid: 'radha.menon@example.com',
    website: 'http://www.natyadanceacademy123.edu',
    aboutdescription: 'Well-equipped institute offering classes in classical dance.',
    photos: ['/images/educationalimages/mangalore_a2.jpg'],
    sm_instagram: 'natya_dance_academy123',
    sm_facebook: 'natya_dance_academy123',
    listorder: 14,
    dateListed: '2025-09-11',
    featuredlisting: true,
    AccountStatus: true,
  },
  
 {
    id: 22,
    institutename: 'New Dream pre university college',
    typecategory: 'PU College',
    locationname: 'Mangalore',
    areaname: 'Pandeshwar',
    address1: 'Plot #10, Pandeswar Residency',
    contactnumber: '+91-###-#######7',
    contactperson: 'Mr. Rajesh Kumar',
    emailid: 'rajesh.kumar@example.com',
    website: 'http://www.newdreampreuniversitycollege.edu',
    aboutdescription: 'Well-equipped institute offering classes in 12th grade.',
    photos: ['/images/educationalimages/mangalore_a1.jpg'],
    sm_instagram: 'new_dream_pre_university_college',
    sm_facebook: 'new_dream_pre_university_college',
    sm_youtube: 'new_dream_pre_university_college',
    listorder: 14,
    dateListed: '2025-09-11',
    featuredlisting: true,
    AccountStatus: true,
  },
  {
    id: 23,
    institutename: 'St. Martin pre university college',
    typecategory: 'PU College',
    locationname: 'Mangalore',
    areaname: 'Pandeshwar',
    address1: 'Plot #12340, Pandeswar Residency',
    contactnumber: '+91-###-######8',
    contactperson: 'Ms. Anitha Rao',
    emailid: 'anitha.rao@example.com',
    website: 'http://www.stmartinpreuniversitycollege.edu',
    aboutdescription: 'Well-equipped institute offering classes in 12th grade.',
    photos: ['/images/educationalimages/14_mangalore_kadri_a1.jpg','/images/educationalimages/mangalore_a3.jpg','/images/educationalimages/mangalore_a7.jpg'],

    sm_instagram: 'st_martin_pre_university_college',
    sm_facebook: 'st_martin_pre_university_college',
    sm_youtube: 'st_martin_pre_university_college',
    listorder: 2,
    dateListed: '2025-09-11',
    featuredlisting: true,
    AccountStatus: true,
  }, 
];

export default educationalListings;
